import { LocationType } from '@wix/ambassador-bookings-services-v2-service/types';
export const mapBasketToCalendarSelections = basket => {
  var _basket$location, _basket$location2;
  const location = ((_basket$location = basket.location) == null ? void 0 : _basket$location.type) === LocationType.BUSINESS ? (_basket$location2 = basket.location) == null ? void 0 : _basket$location2.value : undefined;
  return {
    location,
    services: basket.selectedServicesPreferences.map(servicePreferences => {
      var _servicePreferences$v;
      return {
        id: servicePreferences.service.id,
        resources: Object.values(servicePreferences.resources)[0] || [],
        variants: servicePreferences.variant && !((_servicePreferences$v = servicePreferences.variant.choices) != null && _servicePreferences$v[0].staffMemberId) ? [servicePreferences.variant] : undefined,
        addOns: servicePreferences.addOns
      };
    })
  };
};
//# sourceMappingURL=mapBasketToCalendarSelections.js.map